import { type FC } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { type EmailTemplate } from '../../../../models/Scheduling'

interface TemplatePreviewModalProps {
  template?: EmailTemplate
  onClose: () => void
}

export const TemplatePreviewModal: FC<TemplatePreviewModalProps> = ({ template, onClose }) => (
  <Modal
    show
    onHide={onClose}
    header={
      <div className='d-flex flex-column zocks-gap-0.25'>
        <h5 className='mb-0'>{template?.name ?? 'Template preview'}</h5>
        <span className='paragraph-small zocks-text-gray-600'>This is the standard template clients receive.</span>
      </div>
    }
    headerBodySeparator
    body={
      template ? (
        <div className='d-flex flex-column gap-3'>
          <div className='d-flex flex-column zocks-gap-0.25'>
            <span className='lead-small zocks-text-gray-500 text-uppercase'>Subject</span>
            <span className='bold'>{template.subject ?? '—'}</span>
          </div>
          <div className='d-flex flex-column zocks-gap-0.25'>
            <span className='lead-small zocks-text-gray-500 text-uppercase'>Body</span>
            <div className='paragraph-small zocks-text-gray-600'>
              {(template.body ?? '').split('\n').map((line, index) => (
                <div key={index}>{line || ' '}</div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <span className='paragraph-small zocks-text-gray-600'>This template is no longer available.</span>
      )
    }
    showFooterActions
    hideSecondaryAction
    footerPrimaryActionButtonVariant='secondary'
    footerPrimaryActionTitle='Close'
    onFooterPrimaryAction={onClose}
  />
)
